import carInsurance from '../../json/components/HomePages/CarInsurance/launchPadHeroData.json';
import funeralInsurance from '../../json/components/HomePages/FuneralInsurance/launchPadHeroData.json';
import buildingInsurance from '../../json/components/HomePages/BuildingInsurance/launchPadHeroData.json';
import homeContents from '../../json/components/HomePages/HomeContentsInsurance/launchPadHeroData.json';
import lifeInsurance from '../../json/components/HomePages/LifeInsurance/launchPadHeroData.json';
import medicalAid from '../../json/components/HomePages/MedicalAid/launchPadHeroData.json';
import medicalInsurance from '../../json/components/HomePages/MedicalInsurance/launchPadHeroData.json';
import petInsurance from '../../json/components/HomePages/PetInsurance/launchPadHeroData.json';
import businessInsurance from '../../json/components/HomePages/BusinessInsurance/launchPadHeroData.json';
import servicePlans from '../../json/components/HomePages/ServicePlans/launchPadHeroData.json';
import dentsAndScratches from '../../json/components/HomePages/DentsAndScratches/launchPadHeroData.json';
import gapCover from '../../json/components/HomePages/GapCover/launchPadHeroData.json';
import motorWarranty from '../../json/components/HomePages/MotorWarranty/launchPadHeroData.json';
import tyreAndRim from '../../json/components/HomePages/TyreAndRim/launchPadHeroData.json';
import vehicleTracking from '../../json/components/HomePages/VehicleTracking/launchPadHeroData.json';
import travelInsurance from '../../json/components/HomePages/TravelInsurance/launchPadHeroData.json';
import comboInsurance from '../../json/components/HomePages/ComboInsurance/launchPadHeroData.json';
import personalLoans from '../../json/components/HomePages/PersonalLoans/launchPadHeroData.json';
import debtCounselling from '../../json/components/HomePages/DebtCounselling/launchPadHeroData.json';
import debtConsolidation from '../../json/components/HomePages/DebtConsolidation/launchPadHeroData.json';
import commercialProperty from '../../json/components/HomePages/CommercialProperty/launchPadHeroData.json';
import businessLegalCover from '../../json/components/HomePages/BusinessLegalCover/launchPadHeroData.json';
import eventLiabilityCover from '../../json/components/HomePages/EventLiabilityCover/launchPadHeroData.json';
import professionalLiability from '../../json/components/HomePages/ProfessionalLiability/launchPadHeroData.json';
import employeeBenefits from '../../json/components/HomePages/EmployeeBenefits/launchPadHeroData.json';
import motorCycle from '../../json/components/HomePages/MotorCycleInsurance/launchPadHeroData.json';
import fibre from '../../json/components/HomePages/FibrePage/launchPadHeroData.json';
import lifeInsuranceCompanies from '../../json/components/HomePages/LifeInsuranceCompanies/launchPadHeroData.json';
import carInsuranceCompanies from '../../json/components/HomePages/CarInsuranceCompanies/launchPadHeroData.json';
import medicalAidCompanies from '../../json/components/HomePages/MedicalAidCompanies/launchPadHeroData.json';

// The hero card (LaunchPadHero*) content for each product landing page, keyed
// by normalised pathname. Home and the category pages use the LaunchPad
// instead (see LaunchPad/launchPadContent.js). SubPageHero renders from this
// map and scripts/inline-static-hero.js builds the static hero from it.
export const SUB_PAGE_HERO_DATA = {
  '/car-insurance-quote': carInsurance,
  '/car-insurance-quote/companies': carInsuranceCompanies,
  '/medical-aid-quote': medicalAid,
  '/medical-aid-quote/medical-aid-companies': medicalAidCompanies,
  '/medical-gap-cover-quote': gapCover,
  '/medical-insurance-quotes': medicalInsurance,
  '/pet-insurance-quote': petInsurance,
  '/business-insurance-quote': businessInsurance,
  '/business-insurance-quote/business-legal-cover': businessLegalCover,
  '/business-insurance-quote/event-liability-insurance': eventLiabilityCover,
  '/compare-fibre-deals': fibre,
  '/motorcycle-insurance-quote': motorCycle,
  '/employee-benefits-quote': employeeBenefits,
  '/business-insurance-quote/professional-liability-insurance-cover':
    professionalLiability,
  '/buildings-insurance-quote': buildingInsurance,
  '/service-plan-quotes': servicePlans,
  '/dents-and-scratches-quote': dentsAndScratches,
  '/motor-warranty': motorWarranty,
  '/tyre-and-rim-guard': tyreAndRim,
  '/vehicle-tracking-quote': vehicleTracking,
  '/travel-insurance': travelInsurance,
  '/online-insurance-quote': comboInsurance,
  '/personal-loans': personalLoans,
  '/debt-counselling': debtCounselling,
  '/business-insurance-quote/car-and-commercial-property-insurance':
    commercialProperty,
  '/debt-consolidation-loans': debtConsolidation,
  '/life-insurance-quote': lifeInsurance,
  '/life-insurance-quote/life-insurance-companies': lifeInsuranceCompanies,
  '/funeral-insurance-quote': funeralInsurance,
  '/home-insurance-quote': homeContents,
};
